<template>
  <!-- 这个是运营数据的 -->
  <div class="Operational_data_box">
    <div class="GameInfo">
      <div class="info_box">
        <div
          class="nav"
          v-if="
            roleName &&
            (roleName.includes('APP_DEVELOPER') || roleName.includes('ADMIN'))
          "
        >
          <div v-for="(item, index) in menus">
            <router-link
              tag="div"
              class="nav_text CU"
              :class="
                selectedkeys == item.meta.title
                  ? 'nav_text_active'
                  : 'nav_text_hover'
              "
              :to="{ path: item.path, query: { appId: appId } }"
            >
              {{ $t("router." + [item.meta.title]) }}
            </router-link>
          </div>
        </div>

        <div class="nav" v-if="roleName && roleName.includes(`GAME_DEVELOPER`)">
          <div v-for="(item, index) in menus" v-if="item.meta.key != 2">
            <router-link
              tag="div"
              class="nav_text CU"
              :class="
                selectedkeys == item.meta.title
                  ? 'nav_text_active'
                  : 'nav_text_hover'
              "
              :to="{ path: item.path, query: { appId: appId } }"
            >
              {{ $t("router." + [item.meta.title]) }}
            </router-link>
          </div>
        </div>

        <div class="info_sub"><router-view></router-view></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      roleName: localStorage.getItem("roleName"),
      appId: this.$route.query.appId,
      selectedkeys: this.$route.meta.title,
    };
  },
  created() {
    //  判断 首次打开是当前在哪个页面 如果是在基本信息页面
    // if (this.$route.path != '/gameinfo/game') {
    //       this.Versions()
    // }
    // if (this.$route.path != '/gameinfo/basic') {
    //      this.load()
    // }
    // this.load()
  },
  methods: {},

  watch: {
    $route(to, from) {
      console.log("to.meta.title", to.meta.title);
      return (this.selectedkeys = to.meta.title);
    },
  },
  computed: {
    menus() {
      console.log(
        this.$router.options.routes[0].children[0].children[2].children
      );
      return this.$router.options.routes[0].children[0].children[3].children;
    },
  },
};
</script>

<style scoped="scoped">
.info_box {
  width: 1520px;
  /* height: 720px; */
  background-color: #ffffff;
  box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  margin: 40px auto 0;
  display: flex;
  margin-bottom: 105px;
}
.nav {
  width: 165px;
  background-color: #f3f3f3;
}
.nav_text {
  width: 165px;
  height: 52px;
  text-align: center;
  line-height: 52px;
}
.nav_text_active {
  box-sizing: border-box;
  border-left: 4px solid #4990fa;
  background-color: #ffffff;
}
.nav_text_hover:hover {
  background-color: #fafafa;
}
.info_sub {
  width: calc(100% - 165px);
  height: 100%;
  padding-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Operational_data.vue